import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<aside class=controls-hint aria-label="Flight controls"><div class=controls-hint__head><h2>Controls</h2><button type=button class=controls-hint__dismiss>Dismiss</button></div><dl>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=controls-hint__row><dt></dt><dd>`);
import { For } from "solid-js";
import { CONTROL_BINDINGS } from "./keys.ts";

/** The dismissible key chart, driven by the same binding table `keys.ts` maps from. */
export function ControlsHint(props) {
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$2.nextSibling;
    _$addEventListener(_el$4, "click", props.onDismiss, true);
    _$insert(_el$5, _$createComponent(For, {
      each: CONTROL_BINDINGS,
      children: binding => (() => {
        var _el$6 = _tmpl$2(),
          _el$7 = _el$6.firstChild,
          _el$8 = _el$7.nextSibling;
        _$insert(_el$7, () => binding.keys);
        _$insert(_el$8, () => binding.action);
        return _el$6;
      })()
    }));
    return _el$;
  })();
}
_$delegateEvents(["click"]);